import Layout from '@view/layout'
import homePage from '@sub-view/home'

const home = {
  path: '/home',
  component: Layout,
  meta: {
    subMenu: false,
    permission: ["home"],
  },
  children: [
    {
      path: "/home/index",
      name: "home",
      component: homePage,
      meta: {
        icon: "el-icon-s-home",
        title: "首页",
        permission: ["home"],
      }
    }
  ]
};

const user = {
  path: '/user',
  component: Layout,
  meta: {
    subMenu: true,
    title: "用户管理",
    icon: "el-icon-s-custom",
    permission: ["userList","onlineTerminal","authorizationRule"],
  },
  children: [
    {
      path: "/user/list",
      name: "userList",
      component: () => import("@sub-view/userManage/userList"),
      meta: {
        title: "用户列表",
        permission: ["userList"],
      }
    },
    {
      path: "/user/online-terminal",
      name: "onlineTerminal",
      component: () => import("@sub-view/userManage/onlineTerminal"),
      meta: {
        title: "在线终端",
        permission: ["onlineTerminal"],
      }
    },
    // {
    //   path: "/user/authorization-rule",
    //   name: "authorizationRule",
    //   component: () => import("@sub-view/userManage/authorizationRule"),
    //   meta: {
    //     title: "授权规则",
    //     permission: ["authorizationRule"],
    //   }
    // },
  ]
};

const device = {
  path: '/device',
  component: Layout,
  meta: {
    subMenu: true,
    title: "设备管理",
    icon: "el-icon-s-platform",
    permission: ["deviceList", "auditRule"],
  },
  children: [
    {
      path: "/device/list",
      name: "deviceList",
      component: () => import("@sub-view/deviceManage/deviceList"),
      meta: {
        title: "设备列表",
        permission: ["deviceList"],
      }
    },
  ]
};

const shop = {
  path: '/shop',
  component: Layout,
  meta: {
    subMenu: true,
    title: "商家管理",
    icon: "el-icon-s-shop",
    permission: ["shopList", "accountList","userAuth"],
  },
  children: [
    {
      path: "/shop/list",
      name: "shopList",
      component: () => import("@sub-view/shopManage/shopList"),
      meta: {
        title: "商家列表",
        permission: ["shopList"],
      }
    },
    {
      path: "/shop/account",
      name: "accountList",
      component: () => import("@sub-view/shopManage/accountList"),
      meta: {
        title: "账号列表",
        permission: ["accountList"],
      }
    },
    // {
    //   path: "/shop/user-auth",
    //   name: "userAuth",
    //   component: () => import("@sub-view/shopManage/userAuth"),
    //   meta: {
    //     title: "用户授权",
    //     permission: ["userAuth"],
    //   }
    // },
  ]
};

const firmware = {
  path: '/firmware',
  component: Layout,
  meta: {
    subMenu: true,
    title: "固件管理",
    icon: "el-icon-folder-opened",
    permission: ["firmwareList"],
  },
  children: [
    {
      path: "/firmware/list",
      name: "firmwareList",
      component: () => import("@sub-view/firmwareManage/firmwareList"),
      meta: {
        title: "固件列表",
        permission: ["firmwareList"],
      }
    }
  ]
};

const plugin = {
  path: '/plugin',
  component: Layout,
  meta: {
    subMenu: true,
    title: "插件管理",
    icon: "el-icon-paperclip",
    permission: ["pluginList"],
  },
  children: [
    {
      path: "/plugin/list",
      name: "pluginList",
      component: () => import("@sub-view/pluginManage/pluginList"),
      meta: {
        title: "插件列表",
        permission: ["pluginList"],
      }
    }
  ]
};

const sms = {
  path: '/sms',
  component: Layout,
  meta: {
    subMenu: true,
    title: "短信管理",
    icon: "el-icon-message",
    permission: ["smsConfig","smsRecord","smsRule", "smsTemplate"],
  },
  children: [
    // {
    //   path: "/sms/config",
    //   name: "smsConfig",
    //   component: () => import("@sub-view/smsManage/smsConfig"),
    //   meta: {
    //     title: "短信配置",
    //     permission: ["smsConfig"],
    //   }
    // },
    {
      path: "/sms/record",
      name: "smsRecord",
      component: () => import("@sub-view/smsManage/smsRecord"),
      meta: {
        title: "短信记录",
        permission: ["smsRecord"],
      }
    },
    // {
    //   path: "/sms/rule",
    //   name: "smsRule",
    //   component: () => import("@sub-view/smsManage/smsRule"),
    //   meta: {
    //     title: "短信规则",
    //     permission: ["smsRule"],
    //   }
    // },
    {
      path: "/sms/template",
      name: "smsTemplate",
      component: () => import("@sub-view/smsManage/smsTemplate"),
      meta: {
        title: "默认模板",
        permission: ["smsTemplate"],
      }
    },
  ]
};

const bill = {
  path: '/bill',
  component: Layout,
  meta: {
    subMenu: true,
    title: "财务管理",
    icon: "el-icon-s-finance",
    permission: ["shopOrder", "shopTransfer","userConsume","shopConsume"],
  },
  children: [
    // {
    //   path: "/bill/shop-order",
    //   name: "shopOrder",
    //   component: () => import("@sub-view/billManage/shopOrder"),
    //   meta: {
    //     title: "商户订单列表",
    //     permission: ["shopOrder"],
    //   }
    // },
    // {
    //   path: "/bill/shop-transfer",
    //   name: "shopTransfer",
    //   component: () => import("@sub-view/billManage/shopTransfer"),
    //   meta: {
    //     title: "商户转账记录",
    //     permission: ["shopTransfer"],
    //   }
    // },
    // {
    //   path: "/bill/shop-consume",
    //   name: "shopConsume",
    //   component: () => import("@sub-view/billManage/shopConsume"),
    //   meta: {
    //     title: "商户消费记录",
    //     permission: ["shopConsume"],
    //   }
    // },
    {
      path: "/bill/user-consume",
      name: "userConsume",
      component: () => import("@sub-view/billManage/userConsume"),
      meta: {
        title: "用户消费记录",
        permission: ["userConsume"],
      }
    },
  ]
};

const log = {
  path: '/log',
  component: Layout,
  meta: {
    subMenu: true,
    title: "日志管理",
    icon: "el-icon-s-order",
    permission: ["syslog"],
  },
  children: [
    {
      path: "/log/sys",
      name: "syslog",
      component: () => import("@sub-view/logManage/syslog"),
      meta: {
        title: "系统日志",
        permission: ["syslog"],
      }
    },
  ]
};

const portal = {
  path: '/portal',
  component: Layout,
  meta: {
    subMenu: true,
    title: "Portal管理",
    icon: "el-icon-picture",
    permission: ["defaultTemplate","shopPortal"],
  },
  children: [
    {
      path: "/portal/template",
      name: "defaultTemplate",
      component: () => import("@sub-view/portalManage/defaultTemplate"),
      meta: {
        title: "默认模板",
        permission: ["defaultTemplate"],
      }
    },
    {
      path: "/portal/shop",
      name: "shopPortal",
      component: () => import("@sub-view/portalManage/shopPortal"),
      meta: {
        title: "商户Portal",
        permission: ["shopPortal"],
      }
    }
  ]
};

const domain = {
  path: '/domain',
  component: Layout,
  meta: {
    subMenu: false,
    permission: ["domain"],
  },
  children: [
    {
      path: "/domain/index",
      name: "domain",
      component: () => import("@sub-view/domain"),
      meta: {
        icon: "el-icon-attract",
        title: "域名白名单",
        permission: ["domain"],
      }
    }
  ]
};

const permission = {
  path: '/permission',
  component: Layout,
  meta: {
    subMenu: true,
    title: "权限管理",
    icon: "el-icon-s-check",
    permission: ["managerList","roleList","permissionList"],
  },
  children: [
    {
      path: "/permission/manager",
      name: "managerList",
      component: () => import("@sub-view/permissionManage/managerList"),
      meta: {
        title: "账号管理",
        permission: ["managerList"],
      }
    },
    {
      path: "/permission/role",
      name: "roleList",
      component: () => import("@sub-view/permissionManage/roleList"),
      meta: {
        title: "角色管理",
        permission: ["roleList"],
      }
    },
    {
      path: "/permission/list",
      name: "permissionList",
      component: () => import("@sub-view/permissionManage/permissionList"),
      meta: {
        title: "权限管理",
        permission: ["permissionList"],
      }
    }
  ]
};

export const staticRoutes = [
  // 授权页
  {
    path: '/verify',
    name: 'verify',
    component: () => import("@view/verify"),
    hidden: true
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import("@view/login"),
    hidden: true
  },
  // 未找到页面
  {
    path: '/404',
    name: '404',
    component: () => import("@view/error/404"),
    hidden: true
  },
];

export const defaultRoutes = [
  // 斜杠跳转登录页面
  {
    path: '/',
    redirect: '/index',
    hidden: true
  },
  // 没有页面跳转错误页面
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
];

export const dynamicRoutes = [
  // home,
  shop,
  device,
  user,
  firmware,
  plugin,
  sms,
  bill,
  log,
  portal,
  domain,
];

export const adminRoutes = [
  permission
];
